module.exports = __webpack_public_path__ + "img/algemeen4.9832af79.jpg";